import styled from 'styled-components';

export const RCSPreview = styled.div`
  background-color: #FFFFFF;
  position: absolute;
  top: 73px;
  bottom: 89px;
  left: 32px;
  right: 32px;
  color: #000000;

  .selected{
    background-color: #E6E6E6 ;
  }
  .rcs-header {
    background-color: #F2F2F2;
    border-bottom: 1px solid #E5E5E5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    font-size: 12px;
    padding: 0 4px;
    font-family: 'Roboto', sans-serif;
    div{
      display: flex;
      align-items: center;
      justify-content: center;
    }
    svg {
      height: 16px;
      fill: #000000;
      cursor: pointer;
    }
  }

  .rcs-content {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    height: Calc(100% - 80px);
    font-size: 12px;
    font-family: 'Roboto', sans-serif;
    padding: 0 14px;
    overflow-y: auto;
    scrollbar-width: none;

    .state-change{
      display: flex;
      justify-content: end;
      align-items: center;
      width: 100%;
      gap: 5px;
      .selected{
        background-color: #E6E6E6 ;
      }
      button{
        outline: none;
        background-color: transparent;
        font-size: 12px;
        cursor: pointer;
        transition: 0.3s;
        border: 1px solid #E5E5E5;
        border-radius: 25px;
        font-family: 'Roboto', sans-serif !important;
        &:hover:not(:disabled) {
          background-color: #E6E6E6;
        }
        &:disabled {
          cursor: initial;
        }
      }
    }
    .rcs-message {
      display: flex;
      align-items: end;
      font-size: 12px;
      font-family: 'Roboto', sans-serif;
      margin: 10px 0;
      word-break: break-word;
      width: 100%;
      justify-content: start;
      svg {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        margin-right: 5px;
      }
      .rcs-message-text{
        display: flex;
        max-width: Calc(100% - 33px);
        align-items: center;
        justify-content: center;
        border-radius: 15px;
        background-color: #E5E5E5;
        padding: 0 10px;
      }
    }
    .startIcon{

    }
    .rcs-card{

    }

  }
  }
    .rcs-footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: start;
      padding: 0 14px;

      input {
        width: 100%;
        height: 65%;
        border: none;
        outline: none;
        font-size: 12px;
        font-family: 'Roboto', sans-serif;
        border-radius: 25px;
        background-color: #F2F2F2;
        margin: auto;
        padding: 0 25% 0 10px;
      }

      .button-container {
        position: absolute;
        right: 0;
        bottom: 25%;
        margin: 0 20px 0 0;
        height: 50%;
        display: flex;

        svg {
          height: 100%;
          border: none;
          outline: none;
          border-radius: 50%;
          fill: #7A7A7A;
          cursor: pointer;

          &:hover {
            background-color: #E6E6E6;
          }
        }
      }

`;


export const CardContainer = styled.div`
  display: flex;
  margin-bottom: 10px;
  .card-container{
    display: flex;
    flex-direction: row;
    justify-content: start;
    gap: 10px;
    width: 100%;
    overflow-x: auto;
    scrollbar-width: thin;
    scroll-snap-type: x mandatory;
  }
  .card {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 0 0 auto;
    scroll-snap-align: start;
  }
  .card:last-child {
    scroll-snap-align: end;
  }
`;
